import React from "react";
import PropTypes from "prop-types";

export const PasswordPolicyInfo = ({ errors = [] }) => {
  return (
    <div className="tw-text-left">
      {errors.map((error) => {
        return <div key={error}>{error}</div>;
      })}
    </div>
  );
};

PasswordPolicyInfo.propTypes = {
  errors: PropTypes.array,
};
